import { message } from 'antd';
import FileSaver from 'file-saver';
import React, { useContext, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
import { instanceRef } from '../utils/axios';
import UserContext from './user-context';

const SolicitudContext = React.createContext({});

export function SolicitudProvider(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const history = useHistory();
  const datosCambiados = {};
  const [datosOriginales, setDatosOriginales] = useState({});
  const [datosBCP, setDatosBCP] = useState({});
  const { user } = useContext(UserContext);
  const [smsEnviado, setSmsEnviado] = useState(false);
  const [mailEnviado, setMailEnviado] = useState(false);
  const [coordenadasMap, setCoordenadasMap] = useState();
  const [calendarioPagosContext, setCalendarioPagosContext] = useState();
  const [vigenciaPagosContext, setVigenciaPagosContext] = useState();
  const [calendarioForm, setCalendarioForm] = useState({});

  const solicitarRequest = async (
    solicitud,
    empresa,
    type,
    parseoCorrecto,
    options = {}
  ) => {
    const reCaptchaToken = await executeRecaptcha('form/enviar');
    const response = await instanceRef.instance.post(
      `form/enviar`,
      {
        solicitud,
        reCaptchaToken,
        parseoCorrecto,
        datosCambiados,
        datosOriginales,
        datosBCP
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        ...options
      }
    );
    const token = response.data.data.finalHash.hash;
    const url = response.data.data?.finalHash?.crearorden?.ruta;
    if (solicitud.cotizacion.id_producto === 8) {
      const solicitudEnviar = {
        firma: '',
        referencia: '',
        url,
        datosPago: {
          numeroTarjeta: solicitud.numeroTarjeta,
          titularTarjeta: solicitud.titularTarjeta,
          vencimientoTarjeta: solicitud.vencimientoTarjeta,
          marcaTarjeta: solicitud.marcaTarjeta
            ? solicitud.marcaTarjeta.toUpperCase()
            : '',
          numeroCuenta: solicitud.numeroCuenta
        }
      };
      // if (solicitud?.metodoPago?.codigo === 'tarjeta' && card) {
      //   solicitudEnviar.payment_method_client_id = card.id;
      // }
      const reCaptchaToken2 = await executeRecaptcha('form/firmar');
      const response2 = await instanceRef.instance.post(
        `form/firmar?token=${token}`,
        {
          ...solicitudEnviar,
          reCaptchaToken: reCaptchaToken2
        }
      );
      const responsePdf = await instanceRef.instance.post(
        `/archivos/searchone`,
        {
          id: response2.data.data.id,
          type: 'v',
          url: true
        }
      );
      FileSaver.saveAs(responsePdf.data.data.url, 'Voucher');
    } else {
      let link = `/firmar/${response.data.data.finalHash}`;
      if (solicitud.cotizacion.id_producto === 9) {
        link = `/generar-cv/${response.data.data.finalHash}`;
      }
      await callSolicitar(
        response.data.data.finalHash,
        type,
        link,
        empresa,
        solicitud.cotizacion.persona.celular,
        solicitud.cotizacion.persona.correo
      );
    }
    return response;
  };

  const callSolicitar = async (token, type, link, empresa, celular, correo) => {
    if (link) {
      switch (type) {
        case 'sms':
          await sendSms(token, empresa, celular);
          break;
        case 'mail':
          await sendMail(token, empresa, correo);
          break;
        default:
          sendFormulario(link);
          break;
      }
    }
  };

  const sendSms = async (token, empresa, celular) => {
    const reCaptchaToken = await executeRecaptcha('sms/firmar');
    const data = {
      reCaptchaToken,
      persona: {
        celular
      },
      idEmpresa: empresa.id,
      token
    };

    await instanceRef.instance.post(`sms/firmar`, data);
    if (user) {
      const isWhatsapp = empresa.tiene_whatsapp;
      message.info(
        `Recibirá un mensaje de ${
          isWhatsapp ? 'Whatsapp' : 'texto'
        } para firmar el documento`
      );
      history.push('/solicitudes');
    } else {
      setSmsEnviado(true);
    }
  };

  const sendMail = async (token, empresa, correo) => {
    try {
      const reCaptchaToken = await executeRecaptcha('mail/firmar');
      const data = {
        reCaptchaToken,
        persona: {
          correo
        },
        token,
        idEmpresa: empresa.id
      };
      await instanceRef.instance.post(`mail/firmar`, data);
      if (user) {
        message.info(`${correo} recibirá un correo para firmar el documento`);
        history.push('/solicitudes');
      } else {
        setMailEnviado(true);
      }
    } catch (error) {
      // error
    }
  };

  const sendFormulario = async (link) => {
    history.push(link);
  };

  const updateDatosOriginales = async (field, data) => {
    datosOriginales[field] = data;
  };

  const changeData = async (field, data) => {
    datosCambiados[field] = data;
  };

  const cambiarDatosMap = async (coordenadas) => {
    setCoordenadasMap(coordenadas);
  };

  const value = {
    solicitarRequest,
    changeData,
    coordenadasMap,
    cambiarDatosMap,
    smsEnviado,
    datosCambiados,
    setDatosOriginales,
    datosOriginales,
    setDatosBCP,
    datosBCP,
    updateDatosOriginales,
    calendarioPagosContext,
    setCalendarioPagosContext,
    vigenciaPagosContext,
    setVigenciaPagosContext,
    calendarioForm,
    setCalendarioForm,
    mailEnviado
  };
  return <SolicitudContext.Provider value={value} {...props} />;
}

export function useSolicitudContext() {
  const context = React.useContext(SolicitudContext);
  if (!context) {
    throw new Error('useSolicitudContext debe estar dentro del Proveedor ');
  }
  return context;
}
